import { InputStakeholderDialogState } from ".";
import { ProjectStakeholderListInitialState } from "../project-stakeholder-list/ProjectStakeholderListInitialState";

const searchTypeList = [
  { label: "User ID", value: "UserId" },
  { label: "User Name", value: "UserName" },
];

export const InputStakeholderDialogInitialState: InputStakeholderDialogState = {
  isShow: false,
  saved: ProjectStakeholderListInitialState.spreadsheet.tmplateRow,
  edited: ProjectStakeholderListInitialState.spreadsheet.tmplateRow,
  codes: {
    searchTypeList: searchTypeList,
    roleCdList: [],
    teamCdList: [],
  },
  fieldPath: {
    searchStr: "",
    teamCd: "",
    roleCd: "",
  },
  displayFilter: "1",
  fromActionList: false,
  requireRow: false,
  rowIdx: 0,
  status: {
    searchStr: "",
    searchType: "UserId",
    isUpdated: false,
    invalidList: [],
    notFound: false,
  },
};
